import React, { Component } from 'react'
import { object } from 'prop-types'

import Curriculum from './curriculum'
import Header from './header'
import Footer from './footer'

class Data extends Component {

  componentDidMount() {
    //window.print()
  }

  render() {
    const { header, subjects } = this.props
    return (
      <div className="curriculums container">
        <Header header={header} />
        <Curriculum header={header} subjects={subjects} />
        <Footer />
      </div>
    )
  }
}

Data.propTypes = {
  data: object,
}

export default Data



// WEBPACK FOOTER //
// ./src/containers/Print/Curriculums/data.js